"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.hivScreeningMessages = exports.HivScreening = void 0;
const schema_1 = require("../../../schema");
var HivScreening;
(function (HivScreening) {
    HivScreening["POSITIVE"] = "POSITIVE";
    HivScreening["NEGATIVE"] = "NEGATIVE";
    HivScreening["IN_PROGRESS"] = "IN_PROGRESS";
})(HivScreening || (exports.HivScreening = HivScreening = {}));
exports.hivScreeningMessages = {
    [HivScreening.POSITIVE]: {
        id: "htx.microbiologicalProcedures.hiv.hivScreening.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [HivScreening.NEGATIVE]: {
        id: "htx.microbiologicalProcedures.hiv.hivScreening.NEGATIVE",
        defaultMessage: "Negatív"
    },
    [HivScreening.IN_PROGRESS]: {
        id: "htx.microbiologicalProcedures.hiv.hivScreening.IN_PROGRESS",
        defaultMessage: "Folyamatban"
    }
};
const hivScreening = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HivScreening.POSITIVE),
    schema_1.Schema.singleChoiceItem(HivScreening.NEGATIVE),
    schema_1.Schema.singleChoiceItem(HivScreening.IN_PROGRESS)
])
    .interpretation({ vocab: "htx", code: "hiv_screening" })
    .tag({ vocab: "snomed", code: "171121004" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hivScreening })
    .tag({ vocab: "snomed", code: "19030005" })
    .tag({ vocab: "snomed", code: "20135006" });
